var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{attrs:{"new-comment-template-paths":_vm.newCommentTemplatePaths,"with-tabs":_vm.withTabs}})
}
var staticRenderFns = []

export { render, staticRenderFns }